import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQueryClient } = ReactQueryV5;
import CONSTANTS from "core/constants";
import { useMindlerApi } from "api/apiv2";
import { useAppConfig } from "api/config";

type Feature = keyof typeof CONSTANTS.IMPLEMENT_FEATURES;

export const useImplementedFeature = (feature: Feature | null) => {
  const api = useMindlerApi();
  const queryClient = useQueryClient();
  const { config } = useAppConfig();
  const featureOn = feature
    ? Boolean(config?.implementFeatures.includes(feature))
    : false;
  return [
    featureOn as boolean,
    () => queryClient.invalidateQueries(api.application.config.queryFilter()),
  ] as const;
};
